// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

import { GetJobsTypes } from '@/lib/API';
import { dateOf } from '@/lib/time';

export default {
	columns : {
		jobsKey : {
			title  : 'ID',
			sort   : 'number',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 0,
		},
		number : {
			title  : 'Job/Misc. Job #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 1,
		},
		jobsTypeDescription : {
			title        : 'Job Type',
			sort         : 'string',
			filter       : 'dropdown',
			index        : true,
			hidden       : false,
			order        : 2,
			filterColumn : 'jobsType.description'
		},
		type : {
			title  : 'Type',
			sort   : 'string',
			filter : 'dropdown',
			hidden : false,
			order  : 3,
		},
		category : {
			title  : 'Category',
			sort   : 'string',
			filter : 'dropdown',
			hidden : false,
			order  : 4,
		},
		facilities : {
			title         : 'Facility',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 5,
			filterColumn  : 'facilities.[name,number]',
			key           : 'facilities',
			transformText : a => a.reduce( ( allFacilities, facility, index ) => {

				const formattedFacilityText = `${facility.name} No. ${facility.number}`;
				const facilityList          = `${allFacilities}${formattedFacilityText}`;

				if ( index === a.length - 1 ) {
					return facilityList;
				}

				return `${facilityList}<br>`;

			}, '' ),
		},
		manager : {
			title  : 'Project Manager',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 6,
		},
		status : {
			title  : 'Status',
			sort   : 'string',
			filter : 'dropdown',
			index  : true,
			hidden : false,
			order  : 7,
		},
		fundDescription : {
			title        : 'Fund',
			sort         : 'string',
			filter       : 'string',
			index        : true,
			weight       : 10,
			hidden       : false,
			order        : 8,
			filterColumn : 'fund.description'
		},
		tractNumber : {
			title  : 'Tract #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 9,
		},
		name : {
			title  : 'Project Name',
			sort   : 'string',
			filter : 'string',
			index  : true,
			weight : 10,
			hidden : false,
			order  : 10,
		},
		locationDescription : {
			title        : 'Project Location',
			sort         : 'string',
			filter       : 'string',
			index        : true,
			weight       : 10,
			hidden       : false,
			order        : 11,
			filterColumn : 'location.description',
		},
		dateCreated : {
			title         : 'Job Created',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 12,
			transformText : dateOf,
		},
		dateClosed : {
			title         : 'Job Closed',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 13,
			transformText : dateOf,
		},
		dateStarted : {
			title         : 'Construction Started',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 14,
			transformText : a => ( a ? dateOf( a ) : a ),
		},
		dateEnded : {
			title         : 'Construction Ended',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 15,
			transformText : a => ( a ? dateOf( a ) : a ),
		},
		expenseType : {
			title  : 'Expense Type',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 16,
		},

		firmDescription : {
			title        : 'Firm',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 17,
			filterColumn : 'firm.description'
		},

		projectFee : {
			title  : 'Project Fee',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 18,
		},

		devEstimate : {
			title  : 'Dev Estimate',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 19,
		},

		fidEstimate : {
			title  : 'FID Estimate',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 20,
		},

		fidCost : {
			title  : 'FID Cost',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 21,
		},

		actionRequests : {
			title         : 'Action Requests',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 22,
			filterColumn  : 'actionRequests.[number]',
			key           : 'actionRequests',
			transformText : a => a.reduce( ( allActionRequests, actionRequest, index ) => {

				const formattedActionRequestText = `${actionRequest.number}`;
				const actionRequestList          = `${allActionRequests}${formattedActionRequestText}`;

				if ( index === a.length - 1 ) {
					return actionRequestList;
				}

				return `${actionRequestList}<br>`;

			}, '' ),
		},

		pipeDiameter : {
			title  : 'Pipe Diameter',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 23,
		},

		pipeLength : {
			title  : 'Pipe Length',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 24,
		},

		pipeTypeDescription : {
			title        : 'Pipe Type',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 25,
			filterColumn : 'pipeType.description',
		},

		summary : {
			title  : 'Summary',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 26,
		},
	},

	dropdownOptions : {
		jobsTypeDescription : {
			defaultText : 'Select Job Category',
			options     : GetJobsTypes,
		},
		type : {
			defaultText : 'Select a Type',
			options     : [
				{
					text  : 'Job',
					value : 'Job'
				},
				{
					text  : 'Misc Job',
					value : 'Misc Job'
				},
			]
		},
		category : {
			defaultText : 'Select a Category',
			options     : [
				{
					text  : 'Groundwater Sustainability',
					value : 'Groundwater Sustainability'
				},
				{
					text  : 'Surface Water Infrastructure',
					value : 'Surface Water Infrastructure'
				},
				{
					text  : 'Legal & Water Rights Defense',
					value : 'Legal & Water Rights Defense'
				},
			]
		},
		status : {
			defaultText : 'Select a status',
			options     : [
				{
					text  : 'Active',
					value : 'Active'
				},
				{
					text  : 'Complete',
					value : 'Complete'
				},
				{
					text  : 'On Hold',
					value : 'On-Hold'
				},
				{
					text  : 'Built-Out',
					value : 'Built-Out'
				},
			]
		}
	}
};

export const JobStatuses = [
	{
		text  : 'Active',
		value : 'Active',
		color : '#88BA80',
	},
	{
		text  : 'Complete',
		value : 'Complete',
		color : '#2163b1',
	},
	{
		text  : 'On Hold',
		value : 'On Hold',
		color : '#cc0000',
	},
	{
		text  : 'Built Out',
		value : 'Built-Out',
		color : 'orange',
	},
	// {
	// 	text  : 'Closed',
	// 	value : 'Closed',
	// 	color : 'red'
	// }
];
